<img [src]="imageSrc()" [alt]="alt()" />
